import { Field, Form } from 'factorial-form'
import { some } from 'lodash'

export class VonqCampaignForm extends Form {
  constructor(values: Record<string, number>) {
    super(values, {
      yearsOfExperience: 'number',
      educationLevel: 'number',
      seniority: 'number',
      industry: 'number',
      jobCategory: 'number',
    })
  }

  get hasErrors(): boolean {
    return some(this.fields, (field: Field) => field.errors !== null)
  }
}

export class LinkedInCampaignForm extends Form {
  constructor(values: Record<string, string | string[] | boolean>) {
    super(values, {
      countryCode: 'string',
      postalCode: 'string',
      employmentStatus: 'string',
      categories: 'any',
      industries: 'any',
      showPosterInfo: 'string',
    })
  }

  get hasErrors(): boolean {
    return some(this.fields, (field: Field) => field.errors !== null)
  }
}

export class LinkedInContractForm extends Form {
  constructor(values: Record<string, string>) {
    super(values, {
      Company_ID: 'string',
      recruiter_contract_id: 'string',
    })
  }

  get hasErrors(): boolean {
    return some(this.fields, (field: Field) => field.errors !== null)
  }
}
